import ColorInput from '../ColorInput/ColorInput'
import { useRef, useState } from 'react'
import { ReactComponent as TextSizeIcon } from 'assets/icons/text-size.svg'
import { ReactComponent as FontColorIcon } from 'assets/icons/font-color.svg'
import { ReactComponent as BoldIcon } from 'assets/icons/bold.svg'
import { ReactComponent as AllCapsIcon } from 'assets/icons/all-caps.svg'
import { ReactComponent as HideIcon } from 'assets/icons/eye-blocked.svg'
import clsx from 'clsx'

const TextOptions = ({ label, values, onChange, containerRef }) => {
  const [color, setColor] = useState(values.color)
  const ref = useRef(null)

  const colorStyle = {
    height: '32px',
    width: '32px',
    backgroundColor: values.color,
    border: '1px solid #1b1c1f',
    borderRadius: '500em',
  }
  function handleChange(name, value) {
    onChange({ ...values, [name]: value })
  }

  function handleColorSubmit(value) {
    if (values.color !== value) {
      onChange({ ...values, color: value })
    }
  }
  return (
    <div className="text-options" ref={ref}>
      <label>{label}</label>
      <div className="flex items-center">
        <div className="flex items-center mr-2">
          <TextSizeIcon fill="#797982" height="24" />
        </div>

        <div className="w-[80px] relative ">
          <input
            data-tooltip="Font Size"
            type="number"
            className="no-spinner"
            value={parseInt(values.size)}
            onChange={(evt) => handleChange('size', `${evt.target.value}px`)}
          />
          <div className="absolute right-0 top-0 h-full w-[30px] bg-gray-dark text-white-dark flex items-center justify-center rounded-r-half ">
            <span className="opacity-70">px</span>
          </div>
        </div>
        <div className="flex items-center ml-6 mr-2">
          <FontColorIcon fill="#797982" />
        </div>
        <div className="">
          <ColorInput
            tooltip="Font Color"
            hideInput
            hideColorPreview
            hideClear
            value={color}
            containerRef={containerRef}
            icon={<div style={colorStyle}></div>}
            onSubmit={handleColorSubmit}
            onChange={setColor}
          />
        </div>
        <div className="flex items-center ml-6">
          <button
            data-tooltip="Bold"
            className={clsx(
              'w-10 h-10  rounded-half transition flex items-center justify-center',
              {
                'bg-deep hover:bg-deep-dark': values.bold,
                'bg-gray-light hover:bg-gray': !values.bold,
              },
            )}
            onClick={() => handleChange('bold', !values.bold)}
          >
            <BoldIcon fill="#eee" height="15" width="15" />
          </button>
        </div>
        <div className="flex items-center ml-2">
          <button
            data-tooltip="Capitalize"
            className={clsx(
              'w-10 h-10 rounded-half transition flex items-center justify-center',
              {
                'bg-deep hover:bg-deep-dark': values.allCaps,
                'bg-gray-light hover:bg-gray': !values.allCaps,
              },
            )}
            onClick={() => handleChange('allCaps', !values.allCaps)}
          >
            <AllCapsIcon fill="#eee" height="24" width="24" />
          </button>
        </div>
        <div className="flex items-center ml-2">
          <button
            data-tooltip="Hide"
            className={clsx(
              'w-10 h-10 rounded-half transition flex items-center justify-center',
              {
                'bg-deep hover:bg-deep-dark': values.hidden,
                'bg-gray-light hover:bg-gray': !values.hidden,
              },
            )}
            onClick={() => handleChange('hidden', !values.hidden)}
          >
            <HideIcon fill="#eee" height="24" width="24" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default TextOptions
